import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=7b526e72&scoped=true"
import script from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
export * from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=7b526e72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b526e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b526e72')) {
      api.createRecord('7b526e72', component.options)
    } else {
      api.reload('7b526e72', component.options)
    }
    module.hot.accept("./PageSizeSelect.vue?vue&type=template&id=7b526e72&scoped=true", function () {
      api.rerender('7b526e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/History/components/PageSizeSelect/PageSizeSelect.vue"
export default component.exports